import { AuthConfig } from 'angular-oauth2-oidc';

export function getAuth(environment) {
  return {
    // clearHashAfterLogin: false,
    // Url of the Identity Provider
    issuer: environment?.identityUrl,
    // skipIssuerCheck: true,
    // strictDiscoveryDocumentValidation: false,
    // loginUrl: appConfig.identityServerUrl + "/Account/Login",

    // URL of the SPA to redirect the user to after login
    redirectUri: environment?.frontendUrl + '/',
    silentRefreshRedirectUri: environment?.frontendUrl + '/auth/silent-refresh',
    userinfoEndpoint: environment.identityUrl + '/connect/userinfo',
    // postLogoutRedirectUri: appConfig.frontendUrl,
    // The SPA's id. The SPA is registerd with this id at the auth-server
    clientId: 'meddata.web',
    // set the scope for the permissions the client should request
    // The first three are defined by OIDC. The 4th is a usecase-specific one
    scope: 'openid profile offline_access',
    responseType: 'code',
    showDebugInformation: !environment.production,
    sessionChecksEnabled: false,
    requireHttps: false,
  } as AuthConfig
};
